import request from 'services/request';

//

export async function deleteTradeAgreementSellOutValidator(params, cancelToken) {
  //console.log('params', params);
  return request('/Agreements/Api/v1/SellOut/Validators/Delete', {
    method: 'DELETE',
    cancelToken,
    data: params,
  });
}
